import React from 'react';

import swedishIntstitueLogo from '../../assests/si-logo.jpeg';

export function SwedishInstitueLogo({ style }){
  return (
    <img 
      src={swedishIntstitueLogo} 
      alt="Swidish Institue College of Health Sciences logo"
      style={style}  
    />
  );
}